import { useState } from 'react';

function DsaWithCppModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Data Structures and Algorithms",
      content: [
        "What are Data Structures and Algorithms?",
        "Why are Data Structures and Algorithms important?",
        "Basic concepts: Memory allocation, pointers, and references in C++.",
        "Overview of time complexity and space complexity.",
        "Big-O notation: Analyzing algorithm efficiency."
      ]
    },
    {
      title: "Module 2: Arrays and Strings",
      content: [
        "Introduction to Arrays: Declaring and initializing arrays in C++.",
        "Multidimensional arrays: 2D arrays and beyond.",
        "Basic operations on arrays: Traversing, Inserting, Deleting, Searching.",
        "Dynamic arrays and memory management (using pointers).",
        "Introduction to Strings in C++: String literals, functions, and string manipulation.",
        "Array vs. Vector in C++: When to use which?"
      ]
    },
    {
      title: "Module 3: Linked Lists",
      content: [
        "Introduction to Linked Lists: Singly Linked List, Doubly Linked List, and Circular Linked List.",
        "Basic operations on Linked Lists: Insertion, Deletion, Traversal, Searching.",
        "Memory management and pointers in Linked Lists.",
        "Reversing a Linked List: Iterative and Recursive methods.",
        "Detecting and removing loops in a Linked List.",
        "Doubly Linked List vs. Singly Linked List: Advantages and trade-offs."
      ]
    },
    {
      title: "Module 4: Stacks and Queues",
      content: [
        "Introduction to Stack: Basic operations (Push, Pop, Top).",
        "Implementing a Stack using arrays and linked lists in C++.",
        "Applications of Stacks: Infix to Postfix conversion, Balanced Parentheses.",
        "Introduction to Queue: Basic operations (Enqueue, Dequeue, Front).",
        "Implementing a Queue using arrays and linked lists in C++.",
        "Applications of Queues: Circular Queue, Priority Queue, and Deque."
      ]
    },
    {
      title: "Module 5: Recursion and Backtracking",
      content: [
        "Introduction to Recursion: Base case, Recursive case, and Stack memory.",
        "Writing recursive functions in C++.",
        "Solving problems using Recursion: Factorial, Fibonacci, Tower of Hanoi.",
        "Introduction to Backtracking: General concept and applications.",
        "Solving problems using Backtracking: N-Queens Problem, Sudoku Solver.",
        "Optimizing recursive solutions with Memoization and Dynamic Programming."
      ]
    },
    {
      title: "Module 6: Trees - Basics and Traversals",
      content: [
        "Introduction to Trees: Terminology and types of trees (Binary Tree, Binary Search Tree).",
        "Tree Traversals: Preorder, Inorder, Postorder, and Level order traversals.",
        "Recursive and iterative methods for tree traversals.",
        "Binary Search Tree (BST): Insertion, Deletion, and Searching.",
        "AVL Trees and Self-Balancing Binary Search Trees.",
        "Applications of Trees in algorithms and data storage."
      ]
    },
    {
      title: "Module 7: Graphs - Basics and Traversals",
      content: [
        "Introduction to Graphs: Terminology, Directed and Undirected graphs.",
        "Graph Representations: Adjacency Matrix, Adjacency List.",
        "Graph Traversals: Depth-First Search (DFS) and Breadth-First Search (BFS).",
        "Applications of Graphs: Shortest Path, Topological Sorting, Graph Coloring.",
        "Understanding Directed Acyclic Graphs (DAG).",
        "Graph algorithms: Dijkstra's Algorithm, Bellman-Ford Algorithm, Floyd-Warshall Algorithm."
      ]
    },
    {
      title: "Module 8: Heaps",
      content: [
        "Introduction to Heaps: Min-Heap, Max-Heap.",
        "Heap Operations: Insertion, Deletion, Peek.",
        "Building a Heap: Using arrays for heap representation.",
        "Heap Sort: Sorting elements using Heap Data Structure.",
        "Applications of Heaps: Priority Queues and efficient scheduling.",
        "Understanding Heapify: Upward and Downward Heapify."
      ]
    },
    {
      title: "Module 9: Hashing",
      content: [
        "Introduction to Hashing: Hash functions, Hash Tables.",
        "Collision Resolution Techniques: Chaining and Open Addressing.",
        "Applications of Hashing: Caching, Hashmaps in C++ STL.",
        "Designing custom hash functions for different data types.",
        "Analyzing time complexity of hash operations.",
        "Handling large datasets with hash-based approaches."
      ]
    },
    {
      title: "Module 10: Sorting Algorithms",
      content: [
        "Introduction to Sorting: Importance of sorting in problem-solving.",
        "Sorting Algorithms: Bubble Sort, Selection Sort, Insertion Sort.",
        "Efficient Sorting Algorithms: Merge Sort, Quick Sort, Heap Sort.",
        "Understanding the concept of Divide and Conquer in sorting.",
        "Stability in sorting algorithms: What is it and why it matters.",
        "Time Complexity analysis of different sorting algorithms."
      ]
    },
    {
      title: "Module 11: Searching Algorithms",
      content: [
        "Introduction to Searching: Linear Search and Binary Search.",
        "Binary Search on Sorted Arrays: Recursive and Iterative approaches.",
        "Applications of Binary Search: Search in rotated sorted array, Search in 2D matrix.",
        "Exponential Search: Finding bounds for unbounded arrays.",
        "Interpolation Search: A smarter searching technique.",
        "Time complexity of Searching Algorithms."
      ]
    },
    {
      title: "Module 12: Dynamic Programming",
      content: [
        "Introduction to Dynamic Programming (DP): Concept of overlapping subproblems.",
        "Memoization vs Tabulation approach in DP.",
        "Common DP problems: Fibonacci, Knapsack, Longest Common Subsequence.",
        "Solving optimization problems using DP: Matrix Chain Multiplication.",
        "DP on Trees and Graphs.",
        "Time complexity analysis of DP solutions."
      ]
    },
    {
      title: "Module 13: Advanced Data Structures",
      content: [
        "Segment Trees: Introduction, Building and Querying Segment Trees.",
        "Fenwick Tree (Binary Indexed Tree): Introduction and applications.",
        "Trie Data Structure: Storing strings efficiently and applications.",
        "Disjoint Set Union (Union-Find) Data Structure.",
        "Applications of Advanced Data Structures: Range Queries, String Matching.",
        "Time and space complexities of advanced data structures."
      ]
    },
    {
      title: "Module 14: Algorithm Design Techniques",
      content: [
        "Greedy Algorithms: Concept and application of Greedy strategy.",
        "Divide and Conquer: Concept and application in algorithm design.",
        "Backtracking vs Dynamic Programming: How they differ and when to use which.",
        "Branch and Bound: Introduction and use cases.",
        "Amortized Analysis of Algorithms.",
        "Approximation Algorithms and NP-Complete problems."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Data Structures and Algorithms with C++ Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px' }}>{item}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DsaWithCppModule;
